function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "Combined Shape");

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Explorer-Desktop@1440px",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("g", {
  id: "05-Order-Detail_Filled",
  transform: "translate(-1251.000000, -653.000000)",
  fill: "#FFFFFF"
}, React.createElement("g", {
  id: "Detail",
  transform: "translate(496.000000, 258.000000)"
}, React.createElement("g", {
  id: "Group-2",
  transform: "translate(456.000000, 344.000000)"
}, React.createElement("g", {
  id: "Group-3",
  transform: "translate(286.000000, 40.000000)"
}, React.createElement("path", {
  d: "M25.0208153,11 L26.4350288,12.4142136 L21.131,17.718 L22.8980807,19.4852814 L23.6066017,18.7781746 L25.0208153,20.1923882 L24.3122943,20.8994949 L26.4350288,23.0208153 L25.0208153,24.4350288 L22.8980807,22.3137085 L22.1923882,23.0208153 L20.7781746,21.6066017 L21.4838672,20.8994949 L19.716,19.132 L17.9504546,20.8987878 L18.6568542,21.6066017 L17.2426407,23.0208153 L16.536241,22.3130014 L14.4142136,24.4350288 L13,23.0208153 L15.1220275,20.8987878 L14.4142136,20.1923882 L15.8284271,18.7781746 L16.536241,19.4845743 L18.302,17.718 L13,12.4142136 L14.4142136,11 L19.717,16.303 L25.0208153,11 Z",
  id: "Combined-Shape"
}))))));

var SvgCounterTrade = function SvgCounterTrade(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: "14px",
    height: "14px",
    viewBox: "0 0 14 14",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? React.createElement("title", null, title) : null, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgCounterTrade, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/CounterTrade.98353608.svg";
export { ForwardRef as ReactComponent };